import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ActosService {
    private baseUrl = environment.backendUri + 'actos';

    constructor(private http: HttpClient) { }

    getAll(): Observable<any> {
        return this.http.get(this.baseUrl + '/all');
    }

    getProfessorsByShiftAndDay(shiftId: number, schoolYearId: number, dayId?: number): Observable<any> {
        let url = this.baseUrl + `/professorsByShiftAndDay?shiftId=${shiftId}&schoolYearId=${schoolYearId}`;
        if (dayId !== undefined && dayId !== null) {
            url += `&dayId=${dayId}`;
        }
        return this.http.get(url);
    }

    saveProfessors(data: any): Observable<any> {
        return this.http.post(this.baseUrl + '/saveProfessors', data);
    }

    saveAllProfessors(data: any[]): Observable<any> {
        return this.http.post(this.baseUrl + '/saveAllProfessors', data);
    }

    getTeacherScheduleData(employeeId: string, schoolYearId: number): Observable<any> {
        return this.http.get(`${this.baseUrl}/teacher-schedule-data/${employeeId}/${schoolYearId}`);
    }

    downloadReport(schoolYearId: number): Observable<any> {
        return this.http.get(environment.backendUri + `report/actos/${schoolYearId}`, { responseType: 'blob' });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/actos/actos.service.ts